import { DateTime } from "luxon";
import React from "react";

export default function MessageTime(props: { time: number }) {
  return (
    <>{DateTime.fromSeconds(props.time).toFormat("hh:mma").toLowerCase()}</>
  );
}
